<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner
        class="m-2"
        variant="primary"
        role="status"
      ></b-spinner>
    </div>
    <!-- AGRUPADOS -->
    <div class="row" v-if="viewTabela">
      <b-card>
        <b-card-title class="text-center">
          Resumo do Informe de Rendimentos - Por Ano-calendário
        </b-card-title>
        <p class="text-muted text-center mb-0 text-truncate">
          (para ajuste anual da Declaração do Imposto de Renda - Pessoa Física)
        </p>
        <div>
          <apexchart
            class="apex-charts"
            height="450"
            type="bar"
            dir="ltr"
            :series="graficoInformeRendimentos.agrupados.series"
            :options="graficoInformeRendimentos.agrupados.chartOptions"
          ></apexchart>
        </div>
      </b-card>
      <span class="text-center my-2 fst-italic">OBS: Clique nos gráficos acima para fazer o DOWNLOAD do relatório <i class="mdi mdi-cursor-default-click"></i> </span>
    </div>

  </div>
</template>
  
  
<script>
  import PageHeader from "@/components/page-header";
  import {
    graficoInformeRendimentos,
  } from "./data-apex";


  export default {
    components: {
      PageHeader,
    },
    data() {
      return {
        title: "Informe de Rendimentos",
        items: [
          {
            text: "Informe de Rendimentos",
          },
        ],
        graficoInformeRendimentos: {},
        loading: false,
        viewTabela: false,
        desabilitaClick: false
      };
    },

    created() {
      this.loading = true;
      this.buscarDadosGrafico()
    },

    methods:{
      buscarDadosGrafico() {
        this.$http.get("api/contaCorrente/informeRendimentos/buscarGraficoInformeRendimentos")
          .then((response) => {
            this.graficoInformeRendimentos = graficoInformeRendimentos(this, response.data)
            this.loading = false;
            this.viewTabela = true;
            this.$tools.fecharMenu();
          })
      },
      passaDados(ano){
        this.loading = true
        if(this.desabilitaClick == true){
          return 
        } else {
          this.desabilitaClick = true
          this.$http.get("api/contaCorrente/informeRendimentos/gerarRelatorioIR/" + ano, { responseType: 'blob' })
            .then((response) => {
              var blob = new Blob([response.data], {
                type: 'application/pdf'
              });
              var url = window.URL.createObjectURL(blob);
              window.open(url);
              this.loading = false
              this.desabilitaClick = false
            })
        }
      }
    }
  };
</script>